import React from 'react'
import { NoDataSvg, NoFileSvg } from './Svgs'
import './EmptyPage.scss'
interface Props {
    content: string;
    subContent?: string;
    content_type?: string;
    children?: React.ReactNode;
    icon?: React.ReactNode;
    classNames?: string;
    onClick?: () => void;
    contentStyle?: string;
}

const EmptyPage = ({ content, content_type = 'contact', icon, children, classNames, subContent, onClick, contentStyle }: Props) => {
    return (
        <div className={`empty_ground__contact__container ${classNames}`} >
            {children}
            <div className='empty__contact__section'
                onClick={onClick}
            >
                {icon ? icon : content_type === 'contact' ? <NoDataSvg /> : <NoFileSvg />}
                <div className='d-flex flex-column'>
                    <span className={`empty__contact__section__content ${contentStyle ?? ''}`}>{content}</span>
                    <span className='empty__contact__section__sub__content'>{subContent}</span>
                </div>
            </div>
        </div>
    )
}

export default EmptyPage